import { TextAlignProperty, TextTransformProperty } from "csstype";
import React from "react"

enum ElementType {
    Text = "Text",
    Input = "Input",
    Checkbox = "CheckBox",
    DateInput = "DateInput",
    DatePicker = "Datepicker",
    RadioButton = "RadioButton",
    Textarea = "Textarea",
    A8Modal = "A8Modal",
    CustomModal = "CustomModal",
    Otp = "Otp",
    QandA = "QandA",
    Selfie = "Selfie",
    Select ="Select"
}

export const getComputedValues = (id: string): React.CSSProperties | undefined => {
    const childElement = document.getElementById(id)
    if (childElement) {
        const computedStyles = window.getComputedStyle(childElement);
        const camelCaseStyles: any = {};

        for (let i = 0; i < computedStyles.length; i++) {
            const prop = computedStyles[i];
            const value = computedStyles.getPropertyValue(prop);
            const camelProp = kebabToCamel(prop);
            camelCaseStyles[camelProp] = value;
        }
        const selectedStyles = {
            width: camelCaseStyles.width,
            height: camelCaseStyles.height,
            marginTop: camelCaseStyles.marginTop,
            marginBottom: camelCaseStyles.marginBottom,
            marginLeft: camelCaseStyles.marginLeft,
            marginRight: camelCaseStyles.marginRight,
            position: camelCaseStyles.position,
            lineHeight: camelCaseStyles.lineHeight,
        };

        return selectedStyles;
    }
}



export const getElementStyleByType = (type: string, id: string): React.CSSProperties => {
    switch (type) {
        case ElementType.Text:
            return getTextElementWrapperStyles(id)
        case ElementType.Input:
            return getInputElementStyles(id)
        case ElementType.Checkbox:
            return getCheckboxElementStyles(id)
        case ElementType.DateInput:
            return getDateInputElementStyles(id)
        case ElementType.DatePicker:
            return getDatePickerElementStyles(id)
        case ElementType.RadioButton:
            return getRadioButtonElementStyles(id)
        case ElementType.Textarea:
            return getTextareaElementStyles(id)
        case ElementType.A8Modal:
            return getModalStyles(id)
        case ElementType.CustomModal:
            return getCustomModalStyles(id)
        default:
            return getDefaultStyles(type, id)
    }
}

function kebabToCamel(kebab: any) {
    return kebab.replace(/-([a-z])/g, (match: any, letter: any) => letter.toUpperCase());
}

const getTextElementWrapperStyles = (id: string): React.CSSProperties => {
    const wrapper = document.getElementById(`Text-${id}`)
    const child = document.querySelector(`#Text-${id} p.label-component__label-text`) as HTMLElement
    if (wrapper && child) {
        const wrapperStyles = window.getComputedStyle(wrapper);
        const childStyles = window.getComputedStyle(child);
        const wrapper_camelCaseStyles: any = {};

        for (let i = 0; i < wrapperStyles.length; i++) {
            const prop = wrapperStyles[i];
            const value = wrapperStyles.getPropertyValue(prop);
            const camelProp = kebabToCamel(prop);
            wrapper_camelCaseStyles[camelProp] = value;
        }
        const selectedStyles: React.CSSProperties = {
            width: wrapper_camelCaseStyles.width,
            height: wrapper_camelCaseStyles.height,
            margin: wrapper_camelCaseStyles.margin,
            marginTop: wrapper_camelCaseStyles.marginTop,
            marginBottom: wrapper_camelCaseStyles.marginBottom,
            marginLeft: wrapper_camelCaseStyles.marginLeft,
            marginRight: wrapper_camelCaseStyles.marginRight,
            position: wrapper_camelCaseStyles.position,
            lineHeight: wrapper_camelCaseStyles.lineHeight,
            fontWeight: wrapper_camelCaseStyles.fontWeight,
            fontFamily: wrapper_camelCaseStyles.fontFamily,
            fontSize: childStyles.getPropertyValue("font-size"),
            padding: childStyles.getPropertyValue("padding"),
            paddingTop: childStyles.getPropertyValue("padding-top"),
            paddingBottom: childStyles.getPropertyValue("padding-bottom"),
            paddingLeft: childStyles.getPropertyValue("padding-left"),
            paddingRight: childStyles.getPropertyValue("padding-right"),
            borderWidth: wrapper_camelCaseStyles.borderBlockEndWidth,
            borderRadius: wrapper_camelCaseStyles.borderEndStartRadius,
            backgroundColor: wrapper_camelCaseStyles.backgroundColor,
            color: wrapper_camelCaseStyles.color,
        };
        return selectedStyles
    }

    return {}
}

const getInputElementStyles = (id: string): React.CSSProperties => {
    const wrapper = document.getElementById(`Input-${id}`)
    const child = document.querySelector(`#Input-${id} input.text-input__input`) as HTMLElement
    if (wrapper && child) {
        const wrapperStyles = window.getComputedStyle(wrapper);
        const childStyles = window.getComputedStyle(child);
        const wrapper_camelCaseStyles: any = {};

        for (let i = 0; i < wrapperStyles.length; i++) {
            const prop = wrapperStyles[i];
            const value = wrapperStyles.getPropertyValue(prop);
            const camelProp = kebabToCamel(prop);
            wrapper_camelCaseStyles[camelProp] = value;
        }
        const selectedStyles: React.CSSProperties = {
            width: wrapper_camelCaseStyles.width,
            height: wrapper_camelCaseStyles.height,
            margin: wrapper_camelCaseStyles.margin,
            marginTop: wrapper_camelCaseStyles.marginTop,
            marginBottom: wrapper_camelCaseStyles.marginBottom,
            marginLeft: wrapper_camelCaseStyles.marginLeft,
            marginRight: wrapper_camelCaseStyles.marginRight,
            position: wrapper_camelCaseStyles.position,
            lineHeight: wrapper_camelCaseStyles.lineHeight,
            fontWeight: wrapper_camelCaseStyles.fontWeight,
            fontFamily: wrapper_camelCaseStyles.fontFamily,
            fontSize: childStyles.getPropertyValue("font-size"),
            color: childStyles.getPropertyValue("color"),
            backgroundColor: wrapperStyles.getPropertyValue("background-color"),
            borderWidth: childStyles.getPropertyValue("border-width"),
            borderColor: childStyles.getPropertyValue("border-color"),
            borderRadius: childStyles.getPropertyValue("border-radius"),
            padding: childStyles.getPropertyValue("padding"),
            paddingTop: childStyles.getPropertyValue("padding-top"),
            paddingBottom: childStyles.getPropertyValue("padding-bottom"),
            paddingLeft: childStyles.getPropertyValue("padding-left"),
            paddingRight: childStyles.getPropertyValue("padding-right")
        };
        return selectedStyles
    }

    return {}
}

const getModalStyles = (id: string): React.CSSProperties => {
    const wrapper = document.getElementById(`A8Modal-${id}`)
    const child = document.querySelector(`#A8Modal-${id} .modal-component__content`) as HTMLElement
    if (wrapper && child) {
        const childStyles = window.getComputedStyle(child);
        const selectedStyles: React.CSSProperties = {
            width: childStyles.width,
            height: childStyles.height
        };
        return selectedStyles
    }

    return {}
}

const getCustomModalStyles = (id: string): React.CSSProperties => {
    const child = document.querySelector(`#a8modal_${id} .custom-modal-component__inner`) as HTMLElement
    if (child) {
        const childStyles = window.getComputedStyle(child);
        const selectedStyles: React.CSSProperties = {
            width: childStyles.width,
            height: childStyles.height
        };
        return selectedStyles
    }

    return {}
}

const getTextareaElementStyles = (id: string): React.CSSProperties => {
    const wrapper = document.getElementById(`Textarea-${id}`)
    const child = document.querySelector(`#Textarea-${id} textarea.textarea-component__textarea`) as HTMLElement
    if (wrapper && child) {
        const wrapperStyles = window.getComputedStyle(wrapper);
        const childStyles = window.getComputedStyle(child);
        const wrapper_camelCaseStyles: any = {};

        for (let i = 0; i < wrapperStyles.length; i++) {
            const prop = wrapperStyles[i];
            const value = wrapperStyles.getPropertyValue(prop);
            const camelProp = kebabToCamel(prop);
            wrapper_camelCaseStyles[camelProp] = value;
        }
        const selectedStyles: React.CSSProperties = {
            width: wrapper_camelCaseStyles.width,
            height: wrapper_camelCaseStyles.height,
            margin: wrapper_camelCaseStyles.margin,
            marginTop: wrapper_camelCaseStyles.marginTop,
            marginBottom: wrapper_camelCaseStyles.marginBottom,
            marginLeft: wrapper_camelCaseStyles.marginLeft,
            marginRight: wrapper_camelCaseStyles.marginRight,
            position: wrapper_camelCaseStyles.position,
            lineHeight: wrapper_camelCaseStyles.lineHeight,
            fontWeight: wrapper_camelCaseStyles.fontWeight,
            fontFamily: wrapper_camelCaseStyles.fontFamily,
            fontSize: childStyles.getPropertyValue("font-size"),
            color: childStyles.getPropertyValue("color"),
            backgroundColor: wrapperStyles.getPropertyValue("background-color"),
            borderWidth: childStyles.getPropertyValue("border-width"),
            borderColor: childStyles.getPropertyValue("border-color"),
            borderRadius: childStyles.getPropertyValue("border-radius"),
            padding: childStyles.getPropertyValue("padding"),
            paddingTop: childStyles.getPropertyValue("padding-top"),
            paddingBottom: childStyles.getPropertyValue("padding-bottom"),
            paddingLeft: childStyles.getPropertyValue("padding-left"),
            paddingRight: childStyles.getPropertyValue("padding-right")
        };
        return selectedStyles
    }

    return {}
}

const getRadioButtonElementStyles = (id: string): React.CSSProperties => {
    const wrapper = document.getElementById(`RadioButton-${id}`)
    const child = document.querySelector(`#RadioButton-${id} p.radio-button__option__label`) as HTMLElement
    if (wrapper && child) {
        const wrapperStyles = window.getComputedStyle(wrapper);
        const childStyles = window.getComputedStyle(child);
        const wrapper_camelCaseStyles: any = {};

        for (let i = 0; i < wrapperStyles.length; i++) {
            const prop = wrapperStyles[i];
            const value = wrapperStyles.getPropertyValue(prop);
            const camelProp = kebabToCamel(prop);
            wrapper_camelCaseStyles[camelProp] = value;
        }
        const selectedStyles: React.CSSProperties = {
            width: wrapper_camelCaseStyles.width,
            height: wrapper_camelCaseStyles.height,
            margin: wrapper_camelCaseStyles.margin,
            marginTop: wrapper_camelCaseStyles.marginTop,
            marginBottom: wrapper_camelCaseStyles.marginBottom,
            marginLeft: wrapper_camelCaseStyles.marginLeft,
            marginRight: wrapper_camelCaseStyles.marginRight,
            position: wrapper_camelCaseStyles.position,
            lineHeight: wrapper_camelCaseStyles.lineHeight,
            fontWeight: wrapper_camelCaseStyles.fontWeight,
            fontFamily: wrapper_camelCaseStyles.fontFamily,
            fontSize: childStyles.getPropertyValue("font-size"),
            color: childStyles.getPropertyValue("color"),
            backgroundColor: wrapperStyles.getPropertyValue("background-color"),
            borderWidth: childStyles.getPropertyValue("border-width"),
            borderColor: childStyles.getPropertyValue("border-color"),
            borderRadius: childStyles.getPropertyValue("border-radius"),
            padding: childStyles.getPropertyValue("padding"),
            paddingTop: childStyles.getPropertyValue("padding-top"),
            paddingBottom: childStyles.getPropertyValue("padding-bottom"),
            paddingLeft: childStyles.getPropertyValue("padding-left"),
            paddingRight: childStyles.getPropertyValue("padding-right")
        };
        return selectedStyles
    }

    return {}
}

const getDateInputElementStyles = (id: string): React.CSSProperties => {
    const wrapper = document.getElementById(`DateInput-${id}`)
    const child = document.querySelector(`#DateInput-${id}__computed`) as HTMLElement
    if (wrapper && child) {
        const wrapperStyles = window.getComputedStyle(wrapper);
        const childStyles = window.getComputedStyle(child);
        const wrapper_camelCaseStyles: any = {};

        for (let i = 0; i < wrapperStyles.length; i++) {
            const prop = wrapperStyles[i];
            const value = wrapperStyles.getPropertyValue(prop);
            const camelProp = kebabToCamel(prop);
            wrapper_camelCaseStyles[camelProp] = value;
        }
        const selectedStyles: React.CSSProperties = {
            width: wrapper_camelCaseStyles.width,
            height: wrapper_camelCaseStyles.height,
            margin: wrapper_camelCaseStyles.margin,
            marginTop: wrapper_camelCaseStyles.marginTop,
            marginBottom: wrapper_camelCaseStyles.marginBottom,
            marginLeft: wrapper_camelCaseStyles.marginLeft,
            marginRight: wrapper_camelCaseStyles.marginRight,
            position: wrapper_camelCaseStyles.position,
            lineHeight: wrapper_camelCaseStyles.lineHeight,
            fontWeight: wrapper_camelCaseStyles.fontWeight,
            fontFamily: wrapper_camelCaseStyles.fontFamily,
            fontSize: childStyles.getPropertyValue("font-size"),
            color: childStyles.getPropertyValue("color"),
            backgroundColor: wrapperStyles.getPropertyValue("background-color"),
            borderWidth: childStyles.getPropertyValue("border-width"),
            borderColor: childStyles.getPropertyValue("border-color"),
            borderRadius: childStyles.getPropertyValue("border-radius"),
            padding: childStyles.getPropertyValue("padding"),
            paddingTop: childStyles.getPropertyValue("padding-top"),
            paddingBottom: childStyles.getPropertyValue("padding-bottom"),
            paddingLeft: childStyles.getPropertyValue("padding-left"),
            paddingRight: childStyles.getPropertyValue("padding-right")
        };
        child.style.setProperty("--placeholder", childStyles.getPropertyValue("font-size"))
        return selectedStyles
    }

    return {}
}

const getDatePickerElementStyles = (id: string): React.CSSProperties => {
    const wrapper = document.getElementById(`Datepicker-${id}`)
    const child = document.querySelector(`#Datepicker-${id} button.date-picker__container`) as HTMLElement
    if (wrapper && child) {
        const wrapperStyles = window.getComputedStyle(wrapper);
        const childStyles = window.getComputedStyle(child);
        const wrapper_camelCaseStyles: any = {};

        for (let i = 0; i < wrapperStyles.length; i++) {
            const prop = wrapperStyles[i];
            const value = wrapperStyles.getPropertyValue(prop);
            const camelProp = kebabToCamel(prop);
            wrapper_camelCaseStyles[camelProp] = value;
        }
        const selectedStyles: React.CSSProperties = {
            width: wrapper_camelCaseStyles.width,
            height: wrapper_camelCaseStyles.height,
            margin: wrapper_camelCaseStyles.margin,
            marginTop: wrapper_camelCaseStyles.marginTop,
            marginBottom: wrapper_camelCaseStyles.marginBottom,
            marginLeft: wrapper_camelCaseStyles.marginLeft,
            marginRight: wrapper_camelCaseStyles.marginRight,
            position: wrapper_camelCaseStyles.position,
            lineHeight: wrapper_camelCaseStyles.lineHeight,
            fontWeight: wrapper_camelCaseStyles.fontWeight,
            fontFamily: wrapper_camelCaseStyles.fontFamily,
            fontSize: childStyles.getPropertyValue("font-size"),
            color: childStyles.getPropertyValue("color"),
            backgroundColor: wrapperStyles.getPropertyValue("background-color"),
            borderWidth: childStyles.getPropertyValue("border-width"),
            borderColor: childStyles.getPropertyValue("border-color"),
            borderRadius: childStyles.getPropertyValue("border-radius"),
            padding: childStyles.getPropertyValue("padding"),
            paddingTop: childStyles.getPropertyValue("padding-top"),
            paddingBottom: childStyles.getPropertyValue("padding-bottom"),
            paddingLeft: childStyles.getPropertyValue("padding-left"),
            paddingRight: childStyles.getPropertyValue("padding-right")
        };
        child.style.setProperty("--placeholder", childStyles.getPropertyValue("font-size"))
        return selectedStyles
    }

    return {}
}

const getCheckboxElementStyles = (id: string): React.CSSProperties => {
    const wrapper = document.getElementById(`CheckBox-${id}`)
    const child = document.querySelector(`#CheckBox-${id} .checkbox-component__label`) as HTMLElement
    if (wrapper && child) {
        const wrapperStyles = window.getComputedStyle(wrapper);
        const childStyles = window.getComputedStyle(child);
        const wrapper_camelCaseStyles: any = {};

        for (let i = 0; i < wrapperStyles.length; i++) {
            const prop = wrapperStyles[i];
            const value = wrapperStyles.getPropertyValue(prop);
            const camelProp = kebabToCamel(prop);
            wrapper_camelCaseStyles[camelProp] = value;
        }
        const selectedStyles: React.CSSProperties = {
            width: wrapper_camelCaseStyles.width,
            height: wrapper_camelCaseStyles.height,
            margin: wrapper_camelCaseStyles.margin,
            marginTop: wrapper_camelCaseStyles.marginTop,
            marginBottom: wrapper_camelCaseStyles.marginBottom,
            marginLeft: wrapper_camelCaseStyles.marginLeft,
            marginRight: wrapper_camelCaseStyles.marginRight,
            position: wrapper_camelCaseStyles.position,
            lineHeight: wrapper_camelCaseStyles.lineHeight,
            fontWeight: wrapper_camelCaseStyles.fontWeight,
            fontFamily: wrapper_camelCaseStyles.fontFamily,
            fontSize: childStyles.getPropertyValue("font-size"),
            color: childStyles.getPropertyValue("color"),
            backgroundColor: wrapperStyles.getPropertyValue("background-color"),
            borderWidth: childStyles.getPropertyValue("border-width"),
            borderColor: childStyles.getPropertyValue("border-color"),
            borderRadius: childStyles.getPropertyValue("border-radius"),
            padding: childStyles.getPropertyValue("padding"),
            paddingTop: childStyles.getPropertyValue("padding-top"),
            paddingBottom: childStyles.getPropertyValue("padding-bottom"),
            paddingLeft: childStyles.getPropertyValue("padding-left"),
            paddingRight: childStyles.getPropertyValue("padding-right")
        };
        child.style.setProperty("--placeholder", childStyles.getPropertyValue("font-size"))
        return selectedStyles
    }

    return {}
}

const getDefaultStyles = (type: string, id: string): React.CSSProperties => {
    let childElement = document.getElementById(`${type}-${id}`)
    if (childElement) {
        const computedStyles = window.getComputedStyle(childElement);
        const camelCaseStyles: any = {};

        for (let i = 0; i < computedStyles.length; i++) {
            const prop = computedStyles[i];
            const value = computedStyles.getPropertyValue(prop);
            const camelProp = kebabToCamel(prop);
            camelCaseStyles[camelProp] = value;
        }
        const selectedStyles: React.CSSProperties = {
            width: camelCaseStyles.width,
            height: camelCaseStyles.height,
            margin: camelCaseStyles.margin,
            marginTop: camelCaseStyles.marginTop,
            marginBottom: camelCaseStyles.marginBottom,
            marginLeft: camelCaseStyles.marginLeft,
            marginRight: camelCaseStyles.marginRight,
            position: camelCaseStyles.position,
            lineHeight: camelCaseStyles.lineHeight,
            fontWeight: camelCaseStyles.fontWeight,
            fontFamily: camelCaseStyles.fontFamily,
            fontSize: camelCaseStyles.fontSize,
            color: computedStyles.getPropertyValue("color"),
            backgroundColor: computedStyles.getPropertyValue("background-color"),
            borderWidth: computedStyles.getPropertyValue("border-width"),
            borderColor: computedStyles.getPropertyValue("border-color"),
            borderRadius: computedStyles.getPropertyValue("border-radius"),
            padding: computedStyles.getPropertyValue("padding"),
            paddingTop: computedStyles.getPropertyValue("padding-top"),
            paddingBottom: computedStyles.getPropertyValue("padding-bottom"),
            paddingLeft: computedStyles.getPropertyValue("padding-left"),
            paddingRight: computedStyles.getPropertyValue("padding-right")
        };

        return selectedStyles
    }

    return {}

}